import React from 'react';
import { FormControlLabel, Checkbox as MUICheckbox, Stack } from '@mui/material';
import { makeStyles } from '@mui/styles';

import useQuestion from './useQuestion';

const useStyles = makeStyles(() => ({
    readOnly: {
        '&.Mui-disabled > .MuiTypography-root.Mui-disabled': {
            color: '#3C3E45',
            fontSize: '15px',
            '-webkit-text-fill-color': 'unset',
            outline: 'none',
        },
    },
}));

const Checkbox = (props) => {
    const { question, disabled, readOnly } = props;

    const classes = useStyles();

    const { handleCheckbox, chosenVal } = useQuestion(question);

    //#TODO TechDebt - This Component has only had a readOnly state implemented so far. It's full functionality will be implemented after the TSB project.
    return (
        <Stack>
            {question?.options?.map((opt, i) => {
                return (
                    <FormControlLabel
                        key={`question-${question.id}`}
                        value={opt.id}
                        control={
                            <MUICheckbox
                                checked={chosenVal.includes(opt.id)}
                                onChange={handleCheckbox}
                            />
                        }
                        label={opt?.text?.['en-US'] ? opt.text['en-US'] : ''}
                        disabled={disabled || readOnly}
                        className={readOnly ? classes.readOnly : null}
                    />
                );
            })}
        </Stack>
    );
};

export default Checkbox;
